import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import MotorCreditoList from './MotorCreditoList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import MotorCreditoCadastrar from './MotorCreditoCadastrar';
import { Messages } from 'primereact/messages';
import postMotorCredito from '../../service/postMotorCredito';
import putMotorCredito from '../../service/putMotorCredito';

export default function MotorCreditoPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [motorCredito, setMotorCredito] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveMotorCredito = (motorCredito:any) => {
    if(motorCredito.id){
      putMotorCredito(motorCredito).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setMotorCredito(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    else{
      postMotorCredito(motorCredito).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
               
            ]);
          }
        }
        else{
          setMotorCredito(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
               
            ]);
          }
        }
      })
    }
    
    
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setMotorCredito({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-sliders-v" style={{ fontSize: '2.0rem' }}></i> {t('motorCredito')}</h1>
            </div>     
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!motorCredito && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <MotorCreditoList onEdit={(motorCredito:any) => { setMotorCredito(motorCredito);}}></MotorCreditoList>
          </>
        )}
        {motorCredito && (
          <>
           <MotorCreditoCadastrar msgs={msgs} motorCredito={motorCredito} onSave={saveMotorCredito} onClose={() => {setMotorCredito(null)}}></MotorCreditoCadastrar>
          </>
        )}
      </div>
                
    </Container>
  )
}
